package app

import app.layouts.adminMenu
import app.properties.*
import app.settings.backendPath
import kotlinx.html.js.onChangeFunction
import kotlinx.html.js.onClickFunction
import org.w3c.dom.get
import react.*
import react.dom.*
import kotlin.browser.localStorage
import kotlin.browser.window

interface CreditTypeCrudState : RState {
    var creditTypeList: MutableList<CreditType>?
    var newCreditType: CreditType?
}

class CreditTypeCrud : RComponent<RProps, CreditTypeCrudState>() {

    init {
        chackLogin()
        if(localStorage.get("type") != "0") {
            window.location.assign("/")
        }
        axiosGet(backendPath + "/creditType/list").then {
            updateCreditList(it)
        }
    }

    fun updateCreditList(it: dynamic) {
        var listOfCreditType = mutableListOf<CreditType>()
        it.data.forEach { mail ->
            listOfCreditType.add(CreditType(mail.id, mail.name))
        }

        setState {
            creditTypeList = listOfCreditType
        }
    }

    override fun RBuilder.render() {
        if (localStorage["jwt"]!=null) {
            adminMenu()

            div("adminListBlock") {

                div("row") {
                    div("col-4") {
                        input(classes = "form-control") {
                            attrs {
                                value = state.newCreditType?.name ?: ""
                                onChangeFunction = {
                                    val creditType = getTargetValue(it)
                                    setState {
                                        newCreditType = CreditType(null, creditType)
                                    }
                                }
                            }
                        }
                    }
                    div("col-2") {
                        button(classes = "btn btn-outline-dark") {
                            attrs {
                                onClickFunction = {
                                    state.newCreditType?.let { newCreditTypeProperty ->
                                        axiosPost(backendPath+"/creditType/create", newCreditTypeProperty).then {
                                            updateCreditList(it)
                                            setState {
                                                newCreditType = null
                                            }
                                        }
                                    }
                                }
                            }
                            i("fa fa-plus") {  }
                        }
                    }
                }

                state.creditTypeList?.forEachIndexed { index, creditType ->

                    div("row") {
                        div("col") {
                            input(classes = "form-control") {
                                attrs {
                                    value = creditType.name
                                    onChangeFunction = {
                                        val name = getTargetValue(it)
                                        setState {
                                            creditType.name = name
                                            creditTypeList?.set(index, creditType)
                                        }
                                    }
                                }
                            }
                        }
                        div("col-1") {
                            button(classes = "btn btn-outline-dark") {

                                attrs {
                                    onClickFunction = {
                                        axiosPost(backendPath + "/creditType/save", creditType).then {
                                            js("""new PNotify({
                                                    text: 'Պահպանված է',
                                                    type: 'success',
                                                    styling: 'bootstrap3'
                                                });""")
                                            updateCreditList(it)
                                        }
                                    }
                                }

                                i("fa fa-save") {}
                            }
                        }
                        div("col-1") {
                            button(classes = "btn btn-outline-dark") {

                                attrs {
                                    onClickFunction = {
                                        if(kotlin.browser.window.confirm("Ջնջել?")) {
                                            axiosPost(backendPath + "/creditType/delete", creditType).then {
                                                updateCreditList(it)
                                            }
                                        }
                                    }
                                }

                                i("fa fa-trash-alt") {}
                            }
                        }
                    }
                }
            }
        }
    }
}